import { Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function EmptyState({
  title,
  hint,
  icon,
  action,
}: {
  title: string;
  hint?: string;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Center py={48}>
      <Stack align="center" gap="xs" maw={380}>
        <ThemeIcon size={44} radius="xl" variant="light" color="gray">
          {icon ?? <IconInbox size={22} />}
        </ThemeIcon>
        <Text fw={600}>{title}</Text>
        {hint ? (
          <Text fz="sm" c="dimmed" ta="center">
            {hint}
          </Text>
        ) : null}
        {action}
      </Stack>
    </Center>
  );
}
